import { useDataLoader } from "2g-hooks/fetch";
import { useDidUpdateEffect } from "2g-hooks";

import { DATA } from "b2b/api/paths";

import { isEmpty } from "2g-utils-common";

export default function useZadost({ id }) {
  const loader = useDataLoader({
    url: DATA.zadost(id),
    method: "get",
    lazy: isEmpty(id)
  });

  useDidUpdateEffect(() => {
    !loader.loading && loader.loaded && loader.load();
  }, [id]);

  return loader;
}
